/* eslint-disable react/prop-types */
import { PlusIcon, XIcon } from '@heroicons/react/outline';
import React from 'react';
// import Tag from '../common/components/Tag';
import settings from '../common/settings';
import FormFieldDate from '../common/components/FormFieldDate';
import FormFieldTime from '../common/components/FormFieldTime';
import Button from '../components/Button';
import FormFieldPhoneNumber from '../components/forms/FormFieldPhoneNumber';
import FormFieldCheckbox from '../components/forms/FormFieldCheckbox';
import FormFieldSelect from '../components/forms/FormFieldSelect';
import FormFieldWrapper from '../components/forms/FormFieldWrapper';
import Select from '../components/Select';
import FormFieldSearch from '../components/forms/FormFieldSearch';
import MarkdownEditor from '../components/MarkdownEditor';
import FormFieldTextMultiLanguage from '../components/forms/FormFieldTextMultiLanguage';
// import { getValue } from '../components/Select/utils';

const {
  public: { country },
} = settings;

// FIXME: Add prop types

const renderFormField = ({
  ref,
  testId,
  name,
  input,
  meta,
  id,
  type,
  required,
  muted,
  autoComplete,
  label,
  placeholder,
  size,
  suffix,
  schema,
  maxLength,
  minLength,
  readOnly,
  showValueOnly,
  options,
  disabled,
  mode,
  showSearch,
  isMultiLanguage,

  // 'react-select' specific
  isMulti,
  onAfterChange,

  // 'search' specific
  valueSetId,

  // 'collection' specific
  items: collectionItems,
  createText,
  onCreate,
  onRemove,
  renderExtra,
  itemIndex,

  // 'date' specific
  min,
  max,
}) => {
  if (!type) {
    return null;
  }

  if (type === 'markdown') {
    return (
      <FormFieldWrapper
        label={label}
        required={required}
        meta={meta}
        disabled={disabled}
        isNewPresentation
      >
        <MarkdownEditor
          value={input.value}
          onChange={input.onChange}
          isMultiLanguage={isMultiLanguage}
        />
      </FormFieldWrapper>
    );
  }

  if (type === 'collection') {
    const collectionItemsWithLabelOnlyForFirstItem = collectionItems.map(
      (collectionItem, idx) => {
        if (idx === 0) {
          return collectionItem;
        }

        return collectionItem.map((item) => {
          return { ...item, label: null };
        });
      },
    );

    return (
      <div className="stack-6">
        <span className="font-medium">{label}</span>
        {collectionItemsWithLabelOnlyForFirstItem?.map((items, idx) => {
          // NOTE: Disable remove if at least one item cannot be removed
          const cannotRemove = !!items.find((item) => item.canRemove === false);
          const handleOnRemove = () => {
            if (!cannotRemove) {
              onRemove(idx);
            }
          };

          let cols;
          switch (items.length) {
            case 1:
              cols = 'grid-cols-1';
              break;
            case 2:
              cols = 'grid-cols-2';
              break;
            case 3:
              cols = 'grid-cols-3';
              break;
            case 4:
              cols = 'grid-cols-4';
              break;
            default:
              cols = '';
              break;
          }

          return (
            // eslint-disable-next-line react/no-array-index-key
            <div key={`${name}.${idx}`} className="stack-6">
              <div className="cluster-4 items-end">
                <div className={`flex-1 grid gap-4 ${cols} items-end`}>
                  {items.map((item) =>
                    renderFormField({ ...item, itemIndex: idx }),
                  )}
                </div>
                {!disabled && (
                  <Button
                    type="tertiary"
                    icon={<XIcon />}
                    onClick={handleOnRemove}
                    disabled={cannotRemove}
                  />
                )}
              </div>
              {renderExtra && renderExtra(idx)}
            </div>
          );
        })}
        {!showValueOnly && !disabled && (
          <Button
            type="ghost"
            size="medium"
            className="self-start"
            icon={<PlusIcon />}
            onClick={onCreate}
          >
            {createText}
          </Button>
        )}
      </div>
    );
  }

  if (type === 'search') {
    return (
      <FormFieldSearch
        label={label}
        input={input}
        meta={meta}
        placeholder={placeholder}
        allowClear={!required}
        disabled={disabled}
        required={required}
        valueSetId={valueSetId}
      />
    );
  }

  if (type === 'react-select') {
    // TODO: Move read only preview into dedicated FormFieldSelect as with other components
    // const optionsArray = getValue(
    //   options,
    //   input.value,
    //   (opt) => opt.value,
    //   isMulti,
    // );

    // const readOnlyPreview = isMulti ? (
    //   <div className="cluster-2">
    //     {optionsArray?.map((option) => (
    //       <Tag>{option.label}</Tag>
    //     ))}
    //   </div>
    // ) : (
    //   input.value
    // );
    const handleOnAfterChange = (val) =>
      onAfterChange && onAfterChange(val, itemIndex);

    return (
      <FormFieldWrapper
        label={label}
        meta={meta}
        required={required}
        disabled={disabled || showValueOnly}
        muted={muted}
      >
        {/* {showValueOnly ? (
          readOnlyPreview
        ) : ( */}
        <Select
          data-testid={testId}
          options={options}
          value={input.value}
          onChange={input.onChange}
          onAfterChange={handleOnAfterChange}
          placeholder={placeholder}
          isMulti={isMulti}
          isDisabled={disabled || showValueOnly}
          hasError={meta && meta.error && meta.submitFailed}
        />
        {/* )} */}
      </FormFieldWrapper>
    );
  }

  if (type === 'date') {
    return (
      <FormFieldDate
        id={id}
        data-testid={testId}
        name={name}
        label={label}
        required={required}
        disabled={disabled || showValueOnly}
        input={input}
        meta={meta}
        min={min}
        max={max}
      />
    );
  }

  if (type === 'time') {
    return (
      <FormFieldTime
        id={id}
        data-testid={testId}
        name={name}
        label={label}
        required={required}
        disabled={disabled || showValueOnly}
        input={input}
        meta={meta}
      />
    );
  }

  if (type === 'select') {
    return (
      <FormFieldSelect
        data-testid={testId}
        name={name}
        label={label}
        required={required}
        options={options}
        disabled={disabled}
        mode={mode}
        showSearch={showSearch}
        input={input}
        meta={meta}
      />
    );
  }

  if (type === 'checkbox') {
    return (
      <FormFieldCheckbox
        data-testid={testId}
        name={name}
        label={label}
        required={required}
        disabled={disabled}
        input={input}
        meta={meta}
      />
    );
  }

  if (type === 'phone') {
    return (
      <FormFieldPhoneNumber
        data-testid={testId}
        name={name}
        label={label}
        required={required}
        showValueOnly={showValueOnly}
        disabled={disabled}
        input={input}
        meta={meta}
        defaultCountry={country}
      />
    );
  }

  return (
    <FormFieldTextMultiLanguage
      data-testid={testId}
      ref={ref}
      input={input}
      meta={meta}
      id={id}
      name={name}
      type={type}
      required={required}
      muted={muted}
      autoComplete={autoComplete}
      label={label}
      disabled={disabled}
      readOnly={readOnly}
      showValueOnly={showValueOnly}
      placeholder={placeholder}
      size={size}
      suffix={suffix}
      schema={schema}
      minLength={minLength}
      maxLength={maxLength}
      isMultiLanguage={isMultiLanguage}
    />
  );
};

export default renderFormField;
